<script>
  /**
   * Radio — simple radio input wrapper with a slot label.
   *
   * @module Radio
   * @prop {*} group - Bound radio group value.
   * @prop {*} value - Value for this radio input.
   * @slot - Label or content displayed next to the radio.
   */
  export let group
  export let value
</script>

<input class="uk-radio" type="radio" bind:group {value} />
<slot />

<style>
  .uk-radio {
    margin-right: 10px;
  }
</style>
